import { gql } from '@apollo/client'

import { INGREDIENT_KEYWORD_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const INGREDIENT_QUERY = gql`
  query ingredient($id: ID!) {
    ingredient(id: $id) {
      id
      name
      description
      position
      maxPosition
      isWholeFood
      isVague
      updatedAt
      updatedBy {
        id
        name
      }
      node {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
      }
      isExcludedFromSearch
      imageUrl
      notes

      uncategorized {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
      synonyms {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
      varieties {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
      discarded {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
      phrases {
        id
        phrase
        type
      }
      componentIngredients {
        id
        type
      }
      extraIngredients {
        id
        type
      }
      overridesIngredients {
        id
      }
      alternativeIngredients {
        alternativeIngredientId
        dietId
      }
    }
  }
  ${INGREDIENT_KEYWORD_NODE_FRAGMENT}
`

export default INGREDIENT_QUERY
